// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-area{resize:none;word-break:break-word}", "",{"version":3,"sources":["webpack://./client/modules/common/shared/reusableComponents/input/textArea/textArea.css"],"names":[],"mappings":"AAAA,WACC,WAAY,CAEZ,qBAED","sourcesContent":[".text-area {\n\tresize: none;\n\n\tword-break: break-word;\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
